export const removeDuplicates = xs => Array.from(new Set(xs));
